import { createSelector } from 'reselect';
import { getEfectores } from '../efectores'

export function getEfectorList(state) {
  return state.efectorlists;
}

export function getEfectorListById(state, efectorListId) {
  return getEfectorList(state).get(efectorListId);
}


//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentEfectorList = createSelector(
  getEfectorList,
  efectorlists => efectorlists.get(efectorlists.get('currentEfectorListId'))
);

export const getEfectoresForCurrentEfectorList = createSelector(
  getCurrentEfectorList,
  getEfectores,
  ( efectorlist, efectores) => {
    return efectorlist.efectoresIds.map( id => efectores.get(id) || false );
  }
);
